import { connect } from "react-redux";
import { ToastContainer } from "react-toastify";
import AcSimpleTable from "../../components/AcSimpleTable";
import { hideLoading, showLoading } from "../../actions/loaderAction";
import ButtonAdd from "../../components/ButtonAdd";
import InputField from "../../components/InputField";
import SubHeader from "../../components/SubHeader";
import SmallPopup from "../../components/SmallPopup";
import MediumPopup from "../../components/MediumPopup";
import { useEffect, useRef, useState } from "react";
import { showErrorMessage, showSuccessMessage } from "../../utils/common";
import errorMessages from "../../constant/errorMessages";
import { isEmpty, omit, size } from "lodash";
import defaultValues from "../../constant/defaultValues";
import ToolipsCustom from "../../components/ToolipsCustom";
import { createRole, deleteRole, getRoleList, updateRole } from "../../actions/rolesAction";
import regExp from "../../constant/regExpressions";
import { useAuth } from "@/AuthProvider";

function ManageRoles(props) {

    const { admin } = defaultValues;

    const { isAdmin } = useAuth();

    const [tableKey, setTableKey] = useState(0);
    const [offset, setOffset] = useState(admin.OFFSET);
    const [limit, setLimit] = useState(admin.LIMIT);
    const [searchTxt, setSearchTxt] = useState("");
    const [roleList, setRoleList] = useState([]);
    const [totalRows, settotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const [mediummodalShow, setMediumModalShow] = useState(false);
    const [editRoleId, setEditRoleId] = useState();
    const [errors, setErrors] = useState({});
    const [role, setRole] = useState("");
    const [role_slug, setRoleSlug] = useState("");
    const [smallmodalShow, setSmallModalShow] = useState(false);
    const [deleteRoleId, setDeleteRoleId] = useState();
    const initialRef = useRef(true);
    const [columnName, setColumnName] = useState(admin.COLUMN_NAME);
    const [sortDirection, setSortDirection] = useState(admin.SORT_DIRECTION);
    const [nodata, setNoData] = useState(false);
    const [current_page, setCurrentPage] = useState(1);

    const columns = [
        {
            name: "Sr No",
            selector: (row, idx) => {
                return <>{offset + (idx + 1)}</>;
            },
            resizable: true,
            width: "10%"
        },
        {
            name: "Role Name",
            columnName: "name",
            selector: (row) => <div className="tbl-text-wrap-row">{row.name}</div>,
            resizable: true,
            width: "18%",
            sortable: true,
        },
        {
            name: "Role Slug",
            columnName: "slug",
            selector: (row) => <div className="tbl-text-wrap-row">{row.slug}</div>,
            resizable: true,
            width: "18%",
            sortable: true,
        },
        {
            name: "Created at",
            selector: (row) => (
                <div className="text-wrap">
                    {row.created_by ? row.created_at : "-"}
                </div>
            ),
            resizable: true,
            width: "18%",
        },
        {
            name: "Updated at",
            selector: (row) => (
                <div className="text-wrap">
                    {row.updated_by ? row.updated_at : "-"}
                </div>
            ),
            resizable: true,
            width: "18%",
        },
        {
            omit: isAdmin,
            name: "Actions",
            cell: (row) => (
                // !isAdmin &&
                <>
                    {
                        row && row.slug !== "SUP_ADM" && <>
                            <ToolipsCustom
                                subtitle="Edit"
                                className="fa-regular fa-pen-to-square icon-pen border-0 "
                                classNameChild={"data-table-tooltiop"}
                                onClick={() => handleEditClick(row)}
                            ></ToolipsCustom>

                            <ToolipsCustom
                                subtitle="Delete"
                                className="fa-solid fa-trash-can icon-trash border-0 "
                                classNameChild={"data-table-tooltiop"}
                                onClick={() => handleDeleteClick(row.id)}
                            ></ToolipsCustom>
                        </>
                    }
                </>
            ),
            resizable: true,
            ignoreRowClick: true,
            allowoverflow: true,
            button: true,
            width: "18%"

        },
    ];

    const handleSort = async (column, sortDirection) => {
        if (column.name != undefined && column.name != "" && column.name != null) {
            setColumnName(admin.COLUMN_NAME);
            setSortDirection(sortDirection);
            getRoleList(
                offset,
                limit,
                current_page,
                column.columnName,
                sortDirection,
                searchTxt
            );
        } else {
            setColumnName(admin.COLUMN_NAME);
            setSortDirection("DESC");
            getRoleList(
                offset,
                limit,
                current_page,
                admin.COLUMN_NAME,
                sortDirection,
                searchTxt
            );
        }
    };

    const onSearchTextBoxChanged = (e) => {
        setSearchTxt(e.target.value);
        let searchVal = e.target.value;
        if (searchVal.length >= 3 || searchVal.length <= 0) {
            setOffset(admin.OFFSET);
            setColumnName(admin.COLUMN_NAME);
            setSortDirection(admin.SORT_DIRECTION);
            setLimit(admin.LIMIT);
            setTableKey((prev) => prev + 1);
            getRoleList(
                admin.OFFSET,
                admin.LIMIT,
                current_page,
                admin.COLUMN_NAME,
                admin.SORT_DIRECTION,
                e.target.value
            );
        }
    };

    const getRoleList = async (
        offset,
        limit,
        current_page,
        columnName,
        sortDirection,
        searchTxt
    ) => {
        setNoData(false);
        await props.showLoading();
        await props
            .getRolesList(offset, limit, columnName, sortDirection, searchTxt)
            .then((response) => {
                setRoleList([]);
                if (size(response.data) === 0) {
                    setNoData(true);
                }
                setRoleList(response.data);
                settotalRows(response.metadata.total);
            })
            .catch((err) => {
                console.log("Error ==== ", err);
                showErrorMessage("Something Went Wrong!!");
            });
        await props.hideLoading();
    };

    const handleEditClick = async (row) => {
        setErrors({});
        setRole(row.name);
        setRoleSlug(row.slug);
        setEditRoleId(row.id);
        setMediumModalShow(true);
    };

    const handleFocusOut = (e) => {
        let errObj = { ...errors };
        if (e.target.name === "role") {
            if (isEmpty(e.target.value)) {
                errObj.role = errorMessages.FIELD_REQUIRED;
            } else {
                if (size(e.target.value) > 100) {
                    errObj.role = errorMessages.MAX_CHARACTERS_REACHED;
                } else if (!(regExp.role_name.test(e.target.value))) {
                    errObj.role = errorMessages.IN_VALID_FIELD_FORMAT;
                } else {
                    errObj.role = "";
                }
            }
        }
        if (e.target.name === "slug") {
            if (isEmpty(e.target.value)) {
                errObj.role_slug = errorMessages.FIELD_REQUIRED;
            } else {

                if (size(e.target.value) > 100) {
                    errObj.role_slug = errorMessages.MAX_CHARACTERS_REACHED;
                } else if (!(regExp.role_slug.test(e.target.value))) {
                    errObj.role_slug = errorMessages.IN_VALID_FIELD_FORMAT;
                } else {
                    errObj.role_slug = "";
                }
            }
        }
        console.log("errObj ========== ", errObj);
        setErrors(errObj);
    };

    const validForm = () => {
        console.log("validForm is called ........", role, role_slug);
        let er = {};
        let errFlag = 0;

        if (isEmpty(role)) {
            errFlag = 1;
            er.role = errorMessages.FIELD_REQUIRED;
        } else {
            if (size(role) > 100) {
                errFlag = 1;
                er.role = errorMessages.MAX_CHARACTERS_REACHED;
            } else if (!(regExp.role_name.test(role))) {
                errFlag = 1;
                er.role = errorMessages.IN_VALID_FIELD_FORMAT;
            } else {
                er.role = "";
            }
        }

        if (isEmpty(role_slug)) {
            errFlag = 1;
            er.role_slug = errorMessages.FIELD_REQUIRED;
        } else {
            if (size(role) > 100) {
                errFlag = 1;
                er.role_slug = errorMessages.MAX_CHARACTERS_REACHED;
            } else if (!(regExp.role_slug.test(role_slug))) {
                errFlag = 1;
                er.role_slug = errorMessages.IN_VALID_FIELD_FORMAT;
            } else {
                er.role_slug = "";
            }
        }

        console.log("Er ========= ", er, errFlag);

        setErrors(er);
        if (errFlag === 1) {
            return false;
        } else {
            return true;
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validForm()) {
            props.showLoading();
            if (editRoleId > 0) {
                const reqObj = {
                    name: role,
                    role_id: editRoleId
                };
                await props
                    .updateRole(reqObj)
                    .then((response) => {
                        // console.log('countryresponse----countryresponse---countryresponse--', response);
                        if (response.status === true) {
                            setMediumModalShow(false);
                            setOffset(admin.OFFSET);
                            setColumnName(admin.COLUMN_NAME);
                            setSortDirection(admin.SORT_DIRECTION);
                            setLimit(admin.LIMIT);
                            setSearchTxt("");
                            getRoleList(
                                admin.OFFSET,
                                admin.LIMIT,
                                current_page,
                                admin.COLUMN_NAME,
                                admin.SORT_DIRECTION,
                                ""
                            );
                            showSuccessMessage(response.message);
                        } else if (response.status === false) {
                            let errObj = {};
                            if (response.error) {
                                if (response.error.name) {
                                    errObj.role = response.error.name[0];
                                }
                                if (response.error.slug) {
                                    errObj.role_slug = response.error.slug[0];
                                }
                            }
                            setErrors(errObj);
                        }
                    })
                    .catch((err) => {
                        console.log("Error =======> ", err);
                        showErrorMessage("something went wrong!");
                    });
            } else {
                const reqData = {
                    name: role,
                    slug: role_slug
                };
                await props
                    .createRole(reqData)
                    .then((response) => {
                        if (response.status === true) {
                            setMediumModalShow(false);
                            setOffset(admin.OFFSET);
                            setColumnName(admin.COLUMN_NAME);
                            setSortDirection(admin.SORT_DIRECTION);
                            setLimit(admin.LIMIT);
                            setSearchTxt("");
                            getRoleList(
                                admin.OFFSET,
                                admin.LIMIT,
                                current_page,
                                admin.COLUMN_NAME,
                                admin.SORT_DIRECTION,
                                ""
                            );
                            showSuccessMessage(response.message);
                        } else if (response.status === false) {
                            let errObj = {};
                            if (response.error) {
                                if (response.error.name) {
                                    errObj.role = response.error.name[0];
                                }
                                if (response.error.slug) {
                                    errObj.role_slug = response.error.slug[0];
                                }
                            }
                            setErrors(errObj);
                        }
                    })
                    .catch((err) => {
                        console.log("Error ====== ", err);
                        showErrorMessage("Something Went Wrong!!");
                    });
            }
            props.hideLoading();
        }
    };

    const handleChange = (e) => {
        console.log(e.target.name);
        if (e.target.name === "role") {
            setRole(e.target.value);
        }

        if (e.target.name === "slug") {
            setRoleSlug(e.target.value);
        }

    };

    const handleAddRoleClick = () => {
        setRole("");
        setRoleSlug("");
        setErrors({});
        setEditRoleId(0);
        setMediumModalShow(true);
    };

    const handleDeleteClick = (id) => {
        setSmallModalShow(true);
        setDeleteRoleId(id);
    };

    const handleConfirmDeleteClick = () => {
        props
            .deleteRole(deleteRoleId)
            .then((response) => {
                // console.log('delete - response', response);
                if (response.status === true) {
                    showSuccessMessage(response.data);
                    setOffset(admin.OFFSET);
                    setLimit(admin.LIMIT);
                    setColumnName(admin.COLUMN_NAME);
                    setSortDirection(admin.SORT_DIRECTION);
                    setSearchTxt("");
                    getRoleList(
                        admin.OFFSET,
                        admin.LIMIT,
                        current_page,
                        admin.COLUMN_NAME,
                        admin.SORT_DIRECTION,
                        ""
                    );
                } else if (response.status === false) {
                    showErrorMessage(response.error);
                }
                setSmallModalShow(false);
            })
            .catch((err) => {
                console.log("Error == ", err);
                showErrorMessage("Something Went Wrong!!");
            });
    };

    useEffect(() => {
        if (initialRef.current === true) {
            initialRef.current = false;
            getRoleList(
                offset,
                limit,
                current_page,
                columnName,
                sortDirection,
                searchTxt
            );
        }

    }, []);

    return (
        <>
            <div className="data-table-main">
                <div className="AcSimpleTable">
                    <MediumPopup
                        title={editRoleId > 0 ? "Edit Role" : "Create Role"}
                        mediummodalShow={mediummodalShow}
                        setMediumModalShow={setMediumModalShow}
                        onSubmit={handleSubmit}
                        okButtonLabel={editRoleId > 0 ? "Update" : "Create"}
                        closeButtonLabel="Cancel"
                    >
                        <form onSubmit={handleSubmit}>
                            {/* <div className="row justify-content-cetner align-items-center"> */}
                            <div className="row my-3">
                                <div className="col-xl-6 mt-1">
                                    <label className="popup-input-lable field-required">
                                        Role Name
                                    </label>
                                    <InputField
                                        className=""
                                        placeholder={"Enter Role Name"}
                                        name="role"
                                        onChange={handleChange}
                                        onBlur={handleFocusOut}
                                        value={role}
                                        autoComplete="off"
                                        maxLength={100 + 1}
                                    ></InputField>

                                    {errors.role && (
                                        <p
                                            className="invalid-feedback"
                                            style={{ display: "block" }}
                                        >
                                            {errors.role}
                                        </p>
                                    )}

                                </div>
                                <div className="col-xl-6 mt-1">
                                    <label className="popup-input-lable field-required">
                                        Role Slug
                                    </label>
                                    <InputField
                                        className=""
                                        placeholder={"Enter Role Slug"}
                                        name="slug"
                                        onChange={handleChange}
                                        onBlur={handleFocusOut}
                                        value={role_slug}
                                        autoComplete="off"
                                        disabled={editRoleId > 0 ? true : false}
                                        maxLength={100 + 1}
                                    ></InputField>

                                    {errors.role_slug && (
                                        <p
                                            className="invalid-feedback"
                                            style={{ display: "block" }}
                                        >
                                            {errors.role_slug}
                                        </p>
                                    )}

                                </div>
                            </div>
                        </form>
                    </MediumPopup>
                    <SmallPopup
                        title="Delete Role"
                        smallmodalShow={smallmodalShow}
                        setSmallModalShow={setSmallModalShow}
                        onSubmit={handleConfirmDeleteClick}
                        closeButtonLabel="Cancel"
                        okButtonLabel="Delete"
                    >
                        <div className='row my-3'>
                            <div className="col-md-12 p-0">Are you sure you want to delete Role?</div>
                        </div>

                    </SmallPopup>

                    <SubHeader
                        layer1="Dictionary Management"
                        layer2="Verified"
                        layer3="Roles"
                        pageName="Roles"
                        subTitle=""
                        clickable={{
                            layer1: "",
                            layer2: "",
                            layer3: ""
                        }}
                    />

                    <div className="AcSimpleTable">
                        <div className="card1">
                            <div className="table-header-name">
                                <h5 className="table-text py-3">List</h5>
                                <div className="d-flex flex-wrap justify-content-between align-items-center py-3">
                                    <label className="mx-3">Search</label>
                                    <InputField
                                        type="text"
                                        id="filter-text-box"
                                        placeholder="Search..."
                                        className="w-25"
                                        onChange={onSearchTextBoxChanged}
                                        value={searchTxt}
                                        autoComplete="off"
                                    ></InputField>

                                    { !isAdmin && <ButtonAdd
                                        type="button"
                                        className="btn-add me-0"
                                        onClick={handleAddRoleClick}
                                    >
                                        {" "}
                                        <i className="fa-solid fa-circle-plus"></i> Add New Role
                                    </ButtonAdd>}
                                </div>
                            </div>

                            <div className="table-wrapper">
                                <div className="table-container">
                                    {roleList && (
                                        <AcSimpleTable
                                            key={tableKey}
                                            data={roleList}
                                            title=""
                                            pagination={true}
                                            paginationPageSize={limit}
                                            columns={columns}
                                            progressPending={loading}
                                            paginationTotalRows={totalRows}
                                            fixedColumnsStart={admin.FIXED_COLUMNS_START}
                                            getData={getRoleList}
                                            offset={offset}
                                            limit={limit}
                                            columnName={columnName}
                                            sortDirection={sortDirection}
                                            setLimit={setLimit}
                                            setOffset={setOffset}
                                            setColumnName={setColumnName}
                                            setSortDirection={setSortDirection}
                                            setLoading={setLoading}
                                            paginationPerPage={limit}
                                            paginationRowsPerPageOptions={admin.PAGINATE_RANGE}
                                            striped
                                            searchTxt={searchTxt}
                                            sortServer
                                            onSort={handleSort}
                                            defaultSortAsc={false}
                                            noData={nodata}
                                            setCurrentPage={setCurrentPage}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <ToastContainer /> */}
                </div>
            </div>
        </>
    );

}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        getRolesList: (offset, limit, columnName, sortDirection, searchTxt) =>
            dispatch(
                getRoleList(offset, limit, columnName, sortDirection, searchTxt)
            ),
        updateRole: (data) => dispatch(updateRole(data)),
        createRole: (data) => dispatch(createRole(data)),
        deleteRole: (id) => dispatch(deleteRole(id)),
        showLoading: () => dispatch(showLoading()),
        hideLoading: () => dispatch(hideLoading()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageRoles);
